import { useContext } from "react";

import formFieldContext from "./formFieldContext";

export default function useFormField() {
  return useContext(formFieldContext);
}
